// extracted by mini-css-extract-plugin
export default {"wrapper":"coverage-tile-module__wrapper--I5X","term":"coverage-tile-module__term--qQK","group":"coverage-tile-module__group--23h"};